import { Component, OnInit, Output, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VademecumService } from '../vademecum.service';
import { PersonalInfoService } from '../personal-info.service';
import { Booking } from '../booking';

@Component({
  selector: 'app-personal-info',
  templateUrl: './personal-info.component.html',
  styleUrls: ['./personal-info.component.css']
})
export class PersonalInfoComponent implements OnInit {

  personalInfo!: FormGroup;
   
  @Input()
  booking!: Booking;

  @Input()
  submitFail!: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private vademecumService: VademecumService,
    public personalInfoService: PersonalInfoService
  ) { }

  ngOnInit() {
    this.personalInfoService.personalForm = this.formBuilder.group({
      studentMobile: [""],
      firstParentMobile: ["", Validators.required],
      secondParentMobile: [""],
      firstParentFirstName: ["", Validators.required],
      firstParentLastName: ["", Validators.required],
      secondParentFirstName: [""],
      secondParentLastName: [""]
    });
  }



}
